import React from "react";

function PublishIcon({ color = "#000000" }) {
  return (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.837973 6.78078C0.372463 6.62541 0.368004 6.37449 0.846891 6.21466L17.8683 0.533798C18.3401 0.376641 18.6103 0.64095 18.4783 1.10349L13.6145 18.1461C13.4808 18.6184 13.2088 18.6345 13.009 18.1863L9.80394 10.9642L15.1546 3.8207L8.02038 9.17831L0.837973 6.78078Z" fill={color}/>
</svg>

  );
}

export default PublishIcon;
